const resourceIncludeSelector = (state, props = {}) => state.getIn(['resources',`/${props.type}/${props.id}`,'include'], []);
export default resourceIncludeSelector;



/** WEBPACK FOOTER **
 ** ./app/selectors/resourceIncludeSelector.js
 **/